export default __webpack_public_path__ + "static/media/2TataNexonXzaPlus.3f5a5ccd.jpg";